import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CustomsSavedCartsService } from '@services/customs-saved-carts.service';
import { SavedCartFormDialogComponent } from '@spartacus/cart/saved-cart/components';
import { SavedCartFormType } from '@spartacus/cart/saved-cart/root';
import { GlobalMessageType } from '@spartacus/core';

@Component({
  selector: 'app-custom-cart-details-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-cart-details-modal.component.html',
  styleUrl: './custom-cart-details-modal.component.scss',
})
export class CustomCartDetailsModalComponent extends SavedCartFormDialogComponent {
  customSavedCartService = inject(CustomsSavedCartsService);

  private resetSavedCartStates2(): void {
    this.savedCartService.clearCloneSavedCart();
    this.savedCartService.clearSaveCart();
    this.savedCartService.clearRestoreSavedCart();
  }

  override onComplete(success: boolean): void {
    if (success) {
      switch (this.layoutOption) {
        case SavedCartFormType.DELETE: {
          this.customSavedCartService.reload();
          this.routingService.go({ cxRoute: 'savedCarts' });
          this.globalMessageService.add(
            {
              key: 'savedCartDialog.deleteCartSuccess',
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
          this.close('Successfully deleted a saved cart');

          break;
        }

        case SavedCartFormType.SAVE: {
          this.close('Successfully saved cart');
          this.savedCartService.clearSaveCart();

          this.globalMessageService.add(
            {
              key: 'savedCartCartPage.messages.cartSaved',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code,
              },
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );

          break;
        }

        case SavedCartFormType.EDIT: {
          this.close('Successfully edited saved cart');
          this.savedCartService.clearSaveCart();
          this.globalMessageService.add(
            {
              key: 'savedCartDialog.editCartSuccess',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code,
              },
            },

            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );

          break;
        }

        case SavedCartFormType.RESTORE: {
          this.close('Successfully restored saved cart');
          this.routingService.go({ cxRoute: 'savedCarts' });

          this.resetSavedCartStates2();

          break;
        }
      }
    }
  }
}
